import { render, staticRenderFns } from "./TransfersChannelForm.vue?vue&type=template&id=415817a8&scoped=true"
import script from "./TransfersChannelForm.vue?vue&type=script&lang=js"
export * from "./TransfersChannelForm.vue?vue&type=script&lang=js"
import style0 from "./TransfersChannelForm.vue?vue&type=style&index=0&id=415817a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415817a8",
  null
  
)

export default component.exports